import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useAtom, useAtomValue } from 'jotai';

import {
    DatepickerCalendar,
    DatepickerInput,
    DatepickerPanel,
    DatepickerPopover,
    DatepickerWrapper
} from '@/components/base/Datepicker/DatepickerComponent';
import {
    deadlineDateTimeAtom,
    deadlineTimezoneAtom
} from '@/components/pages/giveaway-picker/Atoms/OptionsAtoms';

dayjs.extend(utc);
dayjs.extend(timezone);

export function DatepickerDeadline() {
    const deadlineTimezone = useAtomValue(deadlineTimezoneAtom);
    const [deadlineDateTime, setDeadlineDateTime] = useAtom(deadlineDateTimeAtom);

    const handleChange = (arg: { date: Date }) => {
        const formattedDate = dayjs(arg.date).format('YYYY-MM-DD');
        const currentTime = dayjs(deadlineDateTime).format('HH:mm:00');

        setDeadlineDateTime(`${formattedDate}T${currentTime}`);
    };

    const deadlineDate = deadlineDateTime
        ? dayjs(deadlineDateTime).tz(deadlineTimezone).format('YYYY-MM-DD')
        : dayjs().tz(deadlineTimezone).format('YYYY-MM-DD');

    return (
        <div>
            <DatepickerWrapper
                date={dayjs(deadlineDate).toDate()}
                mode="single"
                onChange={handleChange}
                settings={{
                    lang: 'en',
                    timezone: deadlineTimezone,
                    dateFormat: 'MM/DD/YYYY'
                }}
                dayPickerOptions={{
                    weekStartsOn: 1
                }}>
                <DatepickerPopover>
                    {({ open, setReferenceElement, setPopperElement, styles, attributes }) => (
                        <>
                            <DatepickerInput setReferenceElement={setReferenceElement} />
                            <DatepickerPanel
                                open={open}
                                styles={styles}
                                className="relative z-10 rounded-md border border-icoGray-300 bg-white shadow-icoM"
                                attributes={attributes}
                                setPopperElement={setPopperElement}>
                                <DatepickerCalendar displayDataRetentionBanner />
                            </DatepickerPanel>
                        </>
                    )}
                </DatepickerPopover>
            </DatepickerWrapper>
        </div>
    );
}
